import { useAppKitAccount, useDisconnect } from '@reown/appkit/react';
import { FC, memo, useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import ConnectWalletDialog from '../../shared/ConnectWalletDialog';
// import { TelegramDialog } from '../../shared/TelegramDialog';
import { Wrapper } from '../../shared/wrapper';
import LanguagePicker from './picker';
// import { UserInfoModal } from '../../shared/UserInfoModal';
import { ArrowBack as ArrowIcon } from '@mui/icons-material';
import { useUnit } from 'effector-react';
import { useTranslations } from 'next-intl';
import { toast } from 'react-toastify';
import { AuthApiService } from '../../api/auth/auth.api.service';
import { useAuth, useReferralLink } from '@entities/user/lib/hooks';
import { DialogEnterPrograms } from '../../shared/DialogEnterPrograms';

import { $userStore, updateUser, logout } from '@store';
import LazyImage from '../LazyImage/index';
// import logo_img from './assets/logo_h.png';
// import { ArrowBottomLeft } from 'mdi-material-ui';

import { LocalStorageKey } from '../../hooks';
import {
  $isAccessTokenLoading,
  $isChangeReferrerModal,
  setIsAccessTokenLoading,
  setIsChangeReferrerModal
} from '@entities/user/model';
import { ChangeNameModal } from '../../shared/ChangeNameModal';
import { ConnectCryptoMagnetInstruction } from '../../shared/ConnectCryptoMagnetInstruction';
import { RegisterCryptoMagnetDialog } from '../../shared/RegisterCryptoMagnetDialog';
import { DropDown } from './dropDown';
import { ChangeNickNameModal } from '../../shared/ChangeNickNameModal';
import { UsersApiService } from '../../api/users/users.api.service';
import { useWallet } from '@entities/user/lib/hooks/useWallet';
import { styled } from '@shared/styles';
import { useRouter } from 'next/router';
import { Button } from '@mui/material';
import { useShouldUseDeeplink } from '../../hooks/useShouldUseDeeplink';
import { useProviders } from '@shared/hooks';
import { WALLETS } from '../../constants';
import { resetBrowserData } from '@shared/utils';

export enum Language {
  EN = 'EN',
  RU = 'RU',
  HI = 'HI',
  FR = 'FR'
}

function shortenString(str: string, length?: number, start?: number, end?: number): string {
  if (str.length <= (length || 10)) {
    return str;
  }
  const firstThree = str.slice(0, start || 7);
  const lastThree = str.slice(-(end || 7));

  return `${firstThree}...${lastThree}`;
}

let Navigation: FC<{ className?: string; page?: boolean }> = ({ className, page }) => {
  const { isConnected, address } = useAppKitAccount();
  const { disconnect } = useDisconnect();
  const { user } = useUnit($userStore);
  const { library } = useWallet();
  const { push } = useRouter();
  const { getFirstProviderWalletType } = useProviders();
  const { shouldSkipConnectionModal } = useShouldUseDeeplink();
  const { walletClickHandler } = useAuth();
  const [isWalletDialogOpen, setIsWalletDialogOpen] = useState(false);
  const [isInstructionOpened, setIsInstructionOpened] = useState(false);
  const [isCMRegistrationInfoOpened, setIsCMRegistrationInfoOpened] = useState(false);
  const [isChangeNameModal, setIsChangeNameModal] = useState(false);
  const [isChangeNickNameModal, setIsChangeNickNameModal] = useState(false);
  const [isChangeUsernameSuccess, setIsChangeUsernameSuccess] = useState(false);
  const [isPreRegisterLoading, setIsPreRegisterLoading] = useState(false);
  const handleWalletDialogOpen = () => {
    // TODO: uncomment this if need to connect in DApp browser directly from "connect wallet" button skipping conenction modal

    // const shouldSkip = shouldSkipConnectionModal();
    // if (shouldSkip) {
    //   const injectedWallet = getFirstProviderWalletType();
    //   return walletClickHandler(WALLETS.find(({wallet}) => wallet === injectedWallet).connector)
    // }
    setIsWalletDialogOpen(true);
  };
  const handleWalletDialogClose = () => setIsWalletDialogOpen(false);
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState<null | Element>(null);
  const isLeptop = useMediaQuery({ query: '(max-width: 1280px)' });
  const isMobile = useMediaQuery({ query: '(max-width: 567px)' });
  const isAccessTokenLoading = useUnit($isAccessTokenLoading);
  const accessToken = typeof window !== 'undefined' ? localStorage.getItem(LocalStorageKey.jwt) : undefined;
  const referralLink = useReferralLink();

  const handleCloseChangeUsernameModal = () => {
    setIsChangeNickNameModal(false);
    setIsChangeUsernameSuccess(false);
  };

  useEffect(() => {
    if (accessToken !== null) {
      setIsAccessTokenLoading(false);
    }
  }, [accessToken]);

  useEffect(() => {
    if (isConnected) {
      handleWalletDialogClose();
    }
  }, [isConnected]);

  const handleDisconnect = async () => {
    try {
      await disconnect();
      await logout();
      setDropdownAnchorEl(null);
    } catch (error) {
      console.log(error);
      await resetBrowserData();
      await logout();
      setDropdownAnchorEl(null);
    }
  };

  const handleCopyRefLink = async () => {
    if (!user) {
      return;
    }

    await navigator.clipboard.writeText(referralLink);
    toast.success(t('common.copiedToClipboard'));
    setDropdownAnchorEl(null);
  };

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, isMobile]);

  const handleScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  const [selectedLoginType, setSelectedLoginType] = useState<'telegram' | 'ref' | null>(null);

  const t = useTranslations();
  const isConfirmationModal = useUnit($isChangeReferrerModal);
  const onSubmitConfirmation = async (link: string) => {
    if (isPreRegisterLoading) {
      return;
    }

    if (user?.isRegistrationConfirmed) {
      setIsChangeReferrerModal(false);
      await push('/career', '/career', { locale: user.lang });

      return;
    }

    setIsPreRegisterLoading(true);
    setIsChangeReferrerModal(false);

    const res = await UsersApiService.confirmReferrer(link);

    if (res) {
      updateUser({ isRegistrationConfirmed: true });
      await push('/career', '/career', { locale: user.lang });
    }

    setIsPreRegisterLoading(false);
  };

  // const getQueryParams = (name: string) => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   return urlParams.get(name);
  // };
  // const link = getQueryParams('link');
  //
  // useEffect(() => {
  //   if (typeof link === 'string') {
  //     handleGetUserByLinkFx(link);
  //   }
  // }, [link]);

  const handleChangeName = async (firstname: string, lastname: string) => {
    const res = await AuthApiService.changeNames({ firstname, lastname });

    if (res) {
      toast.success(t('header.dropdown.successUpdated'));
      setIsChangeNameModal(false);
      updateUser({ name: firstname, lastname });
    }
  };
  const handleChangeNickName = async (newNickName: string) => {
    try {
      const data = await UsersApiService.changeNickname(newNickName);

      if (data.data?.message) {
        const signer = await library?.getSigner();

        if (!signer) {
          return;
        }

        const signature = await signer.signMessage(data.data.message);

        await UsersApiService.submitSignature(signature);

        setIsChangeUsernameSuccess(true);
      } else {
        if ('message' in data) {
          if (data?.message === 'Previous signature already in use, wait 2 minutes') {
            toast.error(t('common.nickname.errors.signatureInUse'));
          } else {
            toast.error(t('common.nickname.errors.common'));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const open = Boolean(dropdownAnchorEl);
  const id = open ? 'simple-popper' : undefined;
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !(dropdownRef.current as any)?.contains(event.target as Node)) {
        setDropdownAnchorEl(null);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div style={{ background: isOpen ? '#181424' : '#181424a5' }} className={className}>
      <Wrapper>
        <nav className='navigation flex'>
          <div
            className='logo flex'
            style={page ? { cursor: 'pointer' } : {}}
            onClick={() => (page ? push('/') : undefined)}
          >
            <img src={'/images/icons/landing/logo_h.png'} alt='logo' /> <span>MAGNET</span>
          </div>

          <ul className={`nav_list flex ${isOpen ? 'open' : ''}`}>
            {!page &&
              ['main', 'about', 'ecosystem', 'roadmap'].map((item, idx) => (
                <li key={idx}>
                  <a role='button' onClick={() => handleScroll(item)}>
                    {t(`header.navigation.${item}`)}
                  </a>
                </li>
              ))}

            {isMobile && !page && (
              <li style={{ zIndex: 2, opacity: 1 }}>
                <button
                  ref={dropdownRef}
                  style={{ color: 'black !important', position: 'static' }}
                  className={`wallet_btn wallet_btn_disconnected`}
                >
                  <div
                    style={{ position: 'relative', width: '100%', display: 'flex', gap: 10, justifyContent: 'center' }}
                  >
                    <div
                      className={`wallet_wrapper ${dropdownAnchorEl ? 'wallet_btn_opened' : ''} wallet_click ${
                        isConnected && address && user ? 'wallet_click_connected' : ''
                      }`}
                      onClick={event => {
                        if (isConnected) {
                          // setDropdownAnchorEl(event.currentTarget);
                          setDropdownAnchorEl(dropdownAnchorEl ? null : event.currentTarget);

                          return;
                        }

                        setSelectedLoginType('ref');
                        handleWalletDialogOpen();
                      }}
                    >
                      <LazyImage src={'/images/icons/landing/wallet.svg'} alt='wallet' />
                      <span style={{ color: 'black' }}>
                        {address && isConnected && user ? shortenString(address) : t('header.walletBtn')}
                      </span>
                    </div>
                    {address && isConnected && user ? (
                      <div
                        className='arr_row'
                        onClick={event => {
                          if (isConnected) {
                            // setDropdownAnchorEl(event.currentTarget);
                            setDropdownAnchorEl(dropdownAnchorEl ? null : event.currentTarget);

                            return;
                          }
                          setSelectedLoginType('ref');
                          handleWalletDialogOpen();
                        }}
                      >
                        <ArrowIcon color='error' />
                      </div>
                    ) : (
                      ''
                    )}{' '}
                  </div>
                  <DropDown
                    dropdownAnchorEl={dropdownAnchorEl}
                    handleCopyRefLink={handleCopyRefLink}
                    handleDisconnect={handleDisconnect}
                    isUserRegistered={!!user?.hashedUid}
                    setIsCMRegistrationInfoOpened={setIsCMRegistrationInfoOpened}
                    setIsChangeNameModal={setIsChangeNameModal}
                    setIsChangeNickNameModal={setIsChangeNickNameModal}
                    onClose={() => setDropdownAnchorEl(null)}
                  />
                </button>
              </li>
            )}
            {isMobile && address && isConnected && user && (
              <li>
                <Button
                  sx={{
                    color: 'white',
                    cursor: 'pointer',
                    padding: '5px 15px',
                    borderRadius: 15,
                    background: '#ffffff1A'
                  }}
                  onClick={() => push('/career')}
                >
                  {t(`header.dropdown.visit`)}
                </Button>
              </li>
            )}

            {isLeptop && (
              <li className={`lang_picker ${dropdownAnchorEl ? 'index-1' : 'index-3'}`}>
                <LanguagePicker />
              </li>
            )}
          </ul>
          <div className='nav_wrapper flex'>
            {!isLeptop && <LanguagePicker />}
            {!isMobile && !page && (
              <button
                ref={dropdownRef}
                style={{ color: 'black !important', position: 'relative' }}
                className={`wallet_btn wallet_btn_disconnected`}
              >
                <div
                  style={{ alignItems: 'center' }}
                  className={`wallet_wrapper ${dropdownAnchorEl ? 'wallet_btn_opened' : ''} wallet_click ${
                    isConnected && address && user ? 'wallet_click_connected' : ''
                  }`}
                  onClick={event => {
                    if (isConnected) {
                      // setDropdownAnchorEl(event.currentTarget);
                      setDropdownAnchorEl(dropdownAnchorEl ? null : event.currentTarget);

                      return;
                    }
                    setSelectedLoginType('ref');
                    handleWalletDialogOpen();
                  }}
                >
                  <LazyImage src={'/images/icons/landing/wallet.svg'} alt='wallet' style={{ width: '30px' }} />
                  <span style={{ color: 'black' }}>
                    {address && isConnected && user ? shortenString(address) : t('header.walletBtn')}
                  </span>
                </div>
                {address && isConnected && user ? (
                  <div
                    aria-describedby={id}
                    className='arr_row'
                    onClick={event => {
                      if (isConnected) {
                        // setDropdownAnchorEl(event.currentTarget);
                        setDropdownAnchorEl(dropdownAnchorEl ? null : event.currentTarget);

                        return;
                      }

                      setSelectedLoginType('ref');
                      handleWalletDialogOpen();
                    }}
                  >
                    <ArrowIcon color='error' />
                  </div>
                ) : (
                  ''
                )}
                <DropDown
                  dropdownAnchorEl={dropdownAnchorEl}
                  handleCopyRefLink={handleCopyRefLink}
                  handleDisconnect={handleDisconnect}
                  isUserRegistered={!!user?.hashedUid}
                  setIsCMRegistrationInfoOpened={setIsCMRegistrationInfoOpened}
                  setIsChangeNameModal={setIsChangeNameModal}
                  setIsChangeNickNameModal={setIsChangeNickNameModal}
                />
              </button>
            )}

            <button
              className={`burger ${isOpen ? 'open' : ''}`}
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? 'Close menu' : 'Open menu'}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
      </Wrapper>
      <ConnectWalletDialog open={isWalletDialogOpen} onClose={handleWalletDialogClose} />
      {/*<UserInfoModal open={isInfoModalOpened} onClose={handleInfoModalClose} />*/}
      {/* {selectedLoginType === 'telegram' && <TelegramDialog />} */}
      <DialogEnterPrograms
        onClose={() => setIsChangeReferrerModal(false)}
        onSubmit={onSubmitConfirmation}
        // openDialog={isConfirmationModal && selectedLoginType !== 'telegram'}
        openDialog={isConfirmationModal && selectedLoginType !== 'telegram'}
        parentId={user?.parentId || 1}
      />
      <ConnectCryptoMagnetInstruction opened={isInstructionOpened} onClose={() => setIsInstructionOpened(false)} />
      <RegisterCryptoMagnetDialog
        openDialog={isCMRegistrationInfoOpened}
        onClose={() => setIsCMRegistrationInfoOpened(false)}
      />
      <ChangeNameModal
        isOpened={isChangeNameModal}
        onClose={() => setIsChangeNameModal(false)}
        onSubmit={handleChangeName}
        initialValues={{ firstname: user?.name || '', lastname: user?.lastname || '' }}
      />
      <ChangeNickNameModal
        isOpened={isChangeNickNameModal}
        onClose={handleCloseChangeUsernameModal}
        onSubmit={handleChangeNickName}
        initialValues={{ newNickName: '', oldNickName: user?.username || '' }}
        isSuccess={isChangeUsernameSuccess}
        linkToBot={`${process.env.NEXT_PUBLIC_CRYPTO_MAGNET_URL}/?start=changeTelegramAccount_${btoa(String(user?.id))}`}
      />
    </div>
  );
};

Navigation = styled(Navigation, {
  '&': {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    transition: 'all 0.2s',
    zIndex: 20,
    // background: #181424a5,

    '@to576': {
      transition: 'all 0.05s'
    }
  },
  '& .navigation': {
    minHeight: '72px',
    justifyContent: 'space-between',
    padding: '9.5px 0'
  },
  '& .logo_wrapper': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  '& .logo': {
    minWidth: '143.44px',
    gap: '10px',
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '150%',
    color: 'white',
    // transform: scale(1.33),
    position: 'relative',
    zIndex: 100,
    span: {
      marginLeft: 'auto'
    },
    '@toXL': {
      transform: 'scale(1)'
    }
  },
  '& .nav_list': {
    marginRight: 'auto',
    marginLeft: '64px',
    gap: '32px',
    listStyle: 'none',

    '@toDesktop': {
      // gap: '44px',
      position: 'fixed',
      zIndex: 10,
      // top: '0px',
      right: 0,
      width: '100%',
      background: '#181424',
      alignItems: 'center',
      gap: '60px',
      transition: 'all 0.3s',
      transform: 'translateY(-150vh)',
      top: '61px',
      // padding: 46px 40px,
      padding: '20px 40px'
    },

    '@toTablet': {
      gap: '20px !important',
      padding: '20px 20px'
    },
    '@to992px': {
      gap: '44px'
    },
    '@to576': {
      gap: '30px !important',
      // gap: '20px',
      flexDirection: 'column',
      top: '0px',
      height: '100vh',
      padding: '20px',
      paddingTop: '104px',
      paddingBottom: '60px'
    },

    li: {
      opacity: 0.8,
      transition: 'all 0.2s',
      color: 'white',
      fontSize: '20px',
      lineHeight: '150%',
      a: {
        cursor: 'pointer'
      },

      '&:hover': {
        opacity: 1
      },

      '@toXL': {
        fontSize: '16px'
      },

      '@to650': {
        fontSize: '14px'
      },

      '@to576': {
        opacity: 1,
        fontSize: '22px'
      }
    }
  },
  '& .nav_list.open ': {
    '@toDesktop': {
      transform: 'translateY(0)'
    }
  },
  '& .wallet_btn': {
    display: 'flex',
    gap: '10px',
    // padding: 0 16px,
    background: 'white',
    borderRadius: '100px',
    color: 'black !important',
    fontWeight: 500,
    fontSize: '18px',
    position: 'relative',
    zIndex: 11,
    transition: 'all 0.2s',
    justifyContent: 'center',

    '&:disabled': {
      opacity: 0.8,
      cursor: 'not-allowed'
    },

    '&_connected': {
      minWidth: '285px'
    },
    '&_disconnected': {
      minWidth: '360px'
    },
    '@toXL': {
      fontSize: '16px',
      // 336px
      '&_connected': {
        minWidth: '285px'
      },
      '&_disconnected': {
        minWidth: '335px'
      }
    },
    '@to576': {
      marginTop: 'auto',
      width: '100%',
      textAlign: 'center',
      justifyContent: 'center',
      // 336px
      '&_connected': {
        minWidth: '253px'
      },
      '&_disconnected': {
        minWidth: '285px'
      }
    },
    span: {
      color: 'black !important'
    },

    button: {
      width: '100%',
      height: '100%'
    }
  },

  '& .nav_wrapper': {
    gap: '32px',
    fontSize: '18px',

    '@toXL': {
      fontSize: '16px'
    }
  },
  '& .arr_row': {
    position: 'absolute',
    width: '100%',
    top: 0,
    right: 0,
    height: '100%',
    svg: {
      transform: 'rotate(-90deg)',
      position: 'absolute',
      right: '21px',
      top: '13px',
      '@to576': {
        right: '14px'
      },
      // top: 50%,
      // transform: translateY(-50%),
      path: {
        fill: 'black !important'
      }
    }
  },
  '& .wallet_click': {
    // background-color: red,
    // width: calc(100% - 76px),
    height: '100%',
    padding: '13px 0px',
    paddingRight: 0,
    justifyContent: 'center',

    cursor: 'pointer',

    '&_connected': {
      borderRight: '1px solid black',
      marginRight: '60px',
      '@to576': {
        marginRight: '50px'
      }
    }
  },
  '& .wallet_wrapper': {
    padding: '13px 16px',
    gap: '10px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1,
    position: 'relative',
    width: '100%'
  },
  '& .burger': {
    display: 'none',
    flexDirection: 'column',
    gap: '5px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 100,
    justifyContent: 'space-between',
    width: '18px',
    height: '25px',
    '@toDesktop': {
      display: 'flex',
      width: '27px'
    },

    span: {
      display: 'block',
      width: '18px',
      height: '2px',
      background: 'white',
      transition: 'all 0.3s ease-in-out',
      position: 'absolute',
      left: '5px'
    },
    'span:nth-child(1)': {
      top: '5px'
    },

    'span:nth-child(2)': {
      top: '50%',
      transform: 'translateY(-50%)'
    },

    'span:nth-child(3)': {
      bottom: '5px'
    },
    '&.open': {
      'span:nth-child(1)': {
        transform: 'rotate(45deg)',
        top: '50%',
        left: '5px'
      },

      'span:nth-child(2)': {
        opacity: 0
      },

      'span:nth-child(3)': {
        transform: 'rotate(-45deg)',
        bottom: 'auto',
        top: '50%',
        left: '5px'
      }
    }
  },
  '& .lang_picker': {
    '@from576': {
      marginLeft: 'auto'
    },
    '@to576': {
      '& > div': {
        marginTop: 0
      }
    }
  },
  '& .index-1': {
    zIndex: 1
  },
  '& .index-3': {
    zIndex: 3
  }
});

export default memo(Navigation);
